module.exports = __webpack_public_path__ + "img/nave-03.b412b7bd.jpg";